import { render, staticRenderFns } from "./ImageRecognitionTest.vue?vue&type=template&id=6e18d978&scoped=true&"
import script from "./ImageRecognitionTest.vue?vue&type=script&lang=ts&"
export * from "./ImageRecognitionTest.vue?vue&type=script&lang=ts&"
import style0 from "./ImageRecognitionTest.vue?vue&type=style&index=0&id=6e18d978&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e18d978",
  null
  
)

export default component.exports